import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { colors } from '../../config/constants';
import PageHeading from '../../components/PageHeading/PageHeading';
import Dailog from '../../components/Dailog/Dailog';
import Copy from '../../components/Copy/Copy';
import Dropdown from '../../components/Dropdown/Dropdown';
import { DriveType } from '../../config/enum';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { errorMessage } from '../../config/errorsMsg';
import { errorMessageAutoCapitalize } from '../../config/helpers';
import { keyword, successMessage } from '../../config/keyword';
import StorageBar from '../../components/StorageBar/StorageBar';
import DateFormatter from '../../components/DateFormatter/DateFormatter';

type ResponseProps = {
  id: string;
  code: string;
  drivePath: string;
  type: number;
  memoryUsed: number;
  totalMemory: number;
  totalMemorytype: string;
  updatedDate: string;
};

const driveTypeOptions = [
  { name: keyword.EXTERNAL_STORAGE, id: DriveType.External },
  { name: keyword.LOCAL_STORAGE, id: DriveType.Local },
];

const ServerDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [storageSettingEditCancel, setStorageSettingEditCancel] =
    useState<boolean>(true);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [totalMemoryState, setTotalMemoryState] = useState({
    totalMemory: 0,
    totalMemorytype: '',
  });
  const [storage, setStorage] = useState<ResponseProps>({
    id: '',
    code: '',
    drivePath: '',
    type: 0,
    memoryUsed: 0,
    totalMemory: 0,
    totalMemorytype: '',
    updatedDate: '',
  });
  const [state, setState] = useState<ResponseProps>({
    id: '',
    code: '',
    drivePath: '',
    type: 0,
    memoryUsed: 0,
    totalMemory: 0,
    totalMemorytype: '',
    updatedDate: '',
  });
  const {
    code,
    drivePath,
    type,
    memoryUsed,
    totalMemory,
    updatedDate,
    totalMemorytype,
  } = storage;
  const [timerValue, setTimerValue] = useState(0);
  useEffect(() => {
    const breadcrumb = [
      { path: '/server', name: 'Server' },
      { path: `/serverDetails`, name: 'Server Details' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getStorageById();
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateStorage();
    }
  }, [formError]);

  const storageHandleEditUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
    bytesConverter(totalMemory, totalMemorytype);
  };

  const bytesConverter = (totalMemory: number, totalMemorytype: string) => {
    switch (totalMemorytype) {
      case 'KB':
        return setStorage({
          ...state,
          totalMemory: totalMemory * 1024,
        });
      case 'MB':
        return setStorage({
          ...state,
          totalMemory: totalMemory * 1024 * 1024,
        });
      case 'GB':
        return setStorage({
          ...state,
          totalMemory: totalMemory * 1024 * 1024 * 1024,
        });
      case 'TB':
        return setStorage({
          ...state,
          totalMemory: totalMemory * 1024 * 1024 * 1024 * 1024,
        });
    }
  };

  const validation = () => {
    const error: any = {};
    if (!code) {
      error.code = errorMessage.emptyDriveCode;
    } else if (code.length < 1 && code.length > 16) {
      error.code = errorMessage.drivePathLength;
    }
    if (!drivePath) {
      error.drivePath = errorMessage.emptyDrivePath;
    } else if (drivePath.length > 255) {
      error.drivePath = errorMessage.drivePathLength;
    }
    if (!totalMemory) {
      error.totalMemory = errorMessage.emptyTotalMemory;
    }
    if (totalMemory < 0) {
      error.totalMemory = errorMessage.negativeTotalMemory;
    }
    if (!type) {
      error.type = errorMessage.emptyDriveType;
    }
    return error;
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    if (event.target.name === 'code') {
      const format = /^\S*$/;
      format.test(event.target.value) &&
        setStorage({
          ...storage,
          [event.target.name]: event.target.value,
        });
    } else {
      setStorage({ ...storage, [event.target.name]: event.target.value });
    }
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };

  const gotResponse = (data: ResponseProps) => {
    setStorage(data);
    setState(data);
    setTotalMemoryState(data);
    dispatch(updateIsLoading(false));
  };

  const storageEditCancel = () => {
    setStorageSettingEditCancel(!storageSettingEditCancel);
    getStorageById();
    setFormError({});
    setIsSubmit(false);
  };

  const getStorageById = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/filestore-drives/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.SUCCESS,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const updateStorage = async () => {
    const obj = {
      type: Number(type),
      drivePath: drivePath,
      code: code,
      totalMemory: totalMemory,
    };
    await instance
      .put(`/filestore-drives/${id}`, obj)
      .then((response) => {
        if (response.status === 200) {
          setStorageSettingEditCancel(!storageSettingEditCancel);
          getStorageById();
          const obj = {
            isOpen: true,
            message: successMessage.STORAGE_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || err.response.data.errors.Code[0],
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const deleteStorage = async () => {
    await instance
      .delete(`/filestore-drives/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.STORAGE_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          setTimeout(() => {
            navigate(`/server`);
          }, 1000);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const recalculate = async () => {
    await instance
      .post(`/filestore-drives/${id}/calc-memory`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.RECALCULATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          startTimer();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const memoryCalucalator = (totalMemory: number, usedMemory: number) => {
    if (totalMemory === 0) {
      return 0;
    } else {
      return (usedMemory / totalMemory) * 100;
    }
  };

  useEffect(() => {
    const storedTimerValue = localStorage.getItem('timerValue');
    if (storedTimerValue) {
      setTimerValue(parseInt(storedTimerValue, 10));
      const timerId = setTimeout(() => {
        localStorage.removeItem('timerValue');
      }, parseInt(storedTimerValue, 10));
      return () => clearTimeout(timerId);
    } else {
      setTimerValue(0);
    }
  }, [timerValue]);

  const startTimer = () => {
    const minutes = 3;
    const milliseconds = minutes * 60 * 1000;
    localStorage.setItem('timerValue', milliseconds.toString());
    setTimerValue(milliseconds);

    const timerId = setTimeout(() => {
      localStorage.removeItem('timerValue');
      setTimerValue(0);
    }, milliseconds);

    return () => clearTimeout(timerId);
  };

  return (
    <>
      <div className="px-2">
        <PageHeading label="Server Details" />
        <div className="bg-white p-4 rounded-sm pt-2 relative">
          <div className={`px-4 ${colors.primaryText}`}>
            <div className="my-4">
              <div className="lg:flex items-end lg:space-x-2">
                <StorageBar
                  lable={code}
                  totalMemory={totalMemoryState.totalMemory}
                  usedMemory={memoryUsed}
                />
                <div>
                  {memoryCalucalator(
                    totalMemoryState.totalMemory,
                    memoryUsed
                  ).toFixed(4) + `% used`}
                </div>
                <Button
                  label="Re-calc"
                  buttonType="primary"
                  type="button"
                  onClick={recalculate}
                  disabled={timerValue !== 0}
                />
              </div>
            </div>

            <div className="sm:flex text-md mb-2">
              <div className={'sm:w-1/3'}>Code</div>
              {storageSettingEditCancel ? (
                <div className="text-black flex">
                  <div>{code}</div>
                </div>
              ) : (
                <div className="sm:w-2/4">
                  <Input
                    name={'code'}
                    type={'text'}
                    value={code}
                    placeholder={`Enter code`}
                    onChange={handleChange}
                    error={formError?.code}
                  />
                </div>
              )}
            </div>

            <div className="sm:flex text-md mb-2">
              <div className="sm:w-1/3 ">Drive Path</div>
              {storageSettingEditCancel ? (
                <div className=" text-black flex break-all">
                  <div>{drivePath}</div>
                  <div className="ml-5">
                    <Copy path={drivePath} isOpen={false} />
                  </div>
                </div>
              ) : (
                <div className="sm:w-2/4">
                  <Input
                    name={'drivePath'}
                    type={'text'}
                    value={drivePath}
                    placeholder={`Enter drive path`}
                    onChange={handleChange}
                    error={formError?.drivePath}
                  />
                </div>
              )}
            </div>
            <div className="sm:flex text-md mb-2">
              <div className="sm:w-1/3 ">Drive Type</div>
              {storageSettingEditCancel ? (
                <div className=" text-black flex sm:w-2/4">
                  <div>{type === 1 ? 'External Storage' : 'Local Storage'}</div>
                </div>
              ) : (
                <div className="sm:w-2/4">
                  <Dropdown
                    name={'type'}
                    initialOption={{
                      name: 'Select Type',
                      id: '',
                    }}
                    value={type}
                    options={driveTypeOptions}
                    onChange={handleChange}
                    error={formError?.type}
                  />
                </div>
              )}
            </div>

            <div className="sm:flex text-md mb-2">
              <div className="sm:w-1/3 ">Total Memory</div>
              {storageSettingEditCancel ? (
                <div className=" text-black flex">
                  <div>{(totalMemory / (1024 * 1024 * 1024)).toFixed(4)} GB</div>
                </div>
              ) : (
                <div>
                  <div className="flex">
                    <input
                      className={`w-full xl:w-[200px] h-7 outline-none pl-2 text-sm border-b-2 focus:border-[#0369a1] placeholder-[#808080] ${
                        formError.totalMemory === undefined ? '' : 'border-[red]'
                      }`}
                      value={totalMemory}
                      name={'totalMemory'}
                      type={'number'}
                      placeholder={`Enter total memory`}
                      onChange={handleChange}
                    />
                    <select
                      className={`w-full ml-2 xl:w-[100px] h-7 outline-none pl-2 text-sm border-b-2 focus:border-[#0369a1] placeholder-[#808080] ${
                        formError.totalMemory === undefined ? '' : 'border-[red]'
                      }`}
                      value={totalMemorytype}
                      name="totalMemorytype"
                      onChange={handleChange}
                    >
                      <option value="B">B</option>
                      <option value="KB">KB</option>
                      <option value="MB">MB</option>
                      <option value="GB">GB</option>
                      <option value="TB">TB</option>
                    </select>
                  </div>
                  <div className="text-sm text-[red] ml-2 mt-1">
                    {formError.totalMemory}
                  </div>
                </div>
              )}
            </div>

            {storageSettingEditCancel && (
              <div className="sm:flex text-md mb-2">
                <div className="sm:w-1/3 ">Memory Used</div>
                <div className=" text-black flex">
                  <div>{(memoryUsed / (1024 * 1024 * 1024)).toFixed(4)} GB</div>
                </div>
              </div>
            )}
            {storageSettingEditCancel && (
              <div className="sm:flex text-md mb-2">
                <div className="sm:w-1/3 ">Last updated on</div>
                <div className=" text-black flex">
                  {updatedDate === null ? (
                    '-'
                  ) : (
                    <div>
                      <DateFormatter date={updatedDate} />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="flex items-center justify-end">
            {storageSettingEditCancel ? (
              <div className="flex justify-center md:justify-end pt-5 md:pt-0">
                <Button
                  label="Edit"
                  buttonType="primary"
                  type="button"
                  onClick={() =>
                    setStorageSettingEditCancel(!storageSettingEditCancel)
                  }
                />
              </div>
            ) : (
              <div className="mt-5 flex mx-auto md:mx-0 justify-end w-[250px]">
                <div className="mr-4">
                  <Button
                    label="Update"
                    buttonType="primary"
                    type="button"
                    onClick={() => storageHandleEditUpdate()}
                    disabled={
                      code === state.code &&
                      drivePath === state.drivePath &&
                      Number(type) === state.type &&
                      totalMemory === state.totalMemory &&
                      totalMemorytype === state.totalMemorytype
                    }
                  />
                </div>
                <Button
                  label="Cancel"
                  buttonType="danger"
                  type="button"
                  onClick={() => storageEditCancel()}
                />
              </div>
            )}
          </div>
          <div
            className="absolute top-3 right-5 text-lg cursor-pointer"
            onClick={() => {
              getStorageById();
              setFormError({});
              setStorage({ ...storage, totalMemorytype: 'B' });
            }}
          >
            <i className="fa-solid fa-rotate-right text-[#2b4865]"></i>
          </div>
        </div>
      </div>

      <div className="flex justify-center pt-8">
        <Button
          label="Delete Storage"
          buttonType="danger"
          type="button"
          onClick={() => setIsDeletePopup(true)}
        />
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'Storage'}
          onConfirm={() => {
            deleteStorage();
          }}
        />
      </div>
    </>
  );
};

export default ServerDetails;
